import React, { useEffect, useRef } from 'react';
import styles from './SixthScreen.module.css';
import ScrollReveal from 'scrollreveal';
import AdminSyllabus from './AdminSyllabus';
import Button from '../ReceptionistComponents/button/Button';

const SixthScreenRec = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // ScrollReveal animations for top section
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });

    ScrollReveal().reveal(`.${styles.description}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 100,
    });

    ScrollReveal().reveal(`.${styles.descriptionStrong}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 200,
    });

    ScrollReveal().reveal(`.${styles.subtitle}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 300,
    });
  }, []);

  return (
    <section ref={containerRef} className={styles.container}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>
          אז איך הופכים את הכשרון שלך למערכת משומנת שמכניסה לך כסף?
        </h2>

        <p className={styles.description}>
          אחרי למעלה מעשור בתחום שבהן עבדתי עם חברות ענק, עסקים גדולים וליוויתי בעלות עסקים לצמיחה (כולל צוות של 6 נשים בדיוק כמוך), זיקקתי את כל הידע הפרקטי לתוך נוסחה אחת מדויקת. <br/>  <strong>אני לא כאן כדי ללמד אותך תיאוריות, אלא כדי לתת לך את הכלים שבעלי עסקים מוכנים לשלם עליהם הרבה מאוד כסף.</strong>
        </p>

   

        <h3 className={styles.subtitle}>
          הנה הדרך שבה הקסם קורה, שלב אחרי שלב:
        </h3>

        <AdminSyllabus />
        
       <div className={styles.title}>ולמקרה ותהית אם זה הסוף..</div>
      </div>
    </section>
  );
};

export default SixthScreenRec;
